import { SortDirection } from "@redotech/cockroachdb-codegen/congodb/sort-direction";
import { MIGRATION_TEAM_STATUS_VALUES } from "@redotech/redo-support-v2-migration/verification/count-verification-constants";
import * as z from "zod";

export const SupportV2MigrationTeamStatus = z.enum(
  MIGRATION_TEAM_STATUS_VALUES,
);
export type SupportV2MigrationTeamStatus = z.infer<
  typeof SupportV2MigrationTeamStatus
>;

export const SupportV2MigrationTeamRow = z.object({
  teamId: z.string(),
  teamName: z.string(),
  accountId: z.string().nullable(),
  status: SupportV2MigrationTeamStatus,
  flagEnabled: z.boolean(),
  billingAccepted: z.boolean(),
  latestRunId: z.string().nullable(),
  mongoConversationCount: z.number().nullable(),
  crdbConversationCount: z.number().nullable(),
  updatedAt: z.string().datetime(),
});
export type SupportV2MigrationTeamRow = z.infer<
  typeof SupportV2MigrationTeamRow
>;

export const SupportV2MigrationTeamSortKey = z.enum([
  "team",
  "status",
  "flagEnabled",
  "billingAccepted",
  "mongoConversationCount",
  "crdbConversationCount",
  "updatedAt",
]);
export type SupportV2MigrationTeamSortKey = z.infer<
  typeof SupportV2MigrationTeamSortKey
>;

export const SupportV2MigrationTeamSortDirection = z.enum(
  Object.values(SortDirection) as [SortDirection.Asc, SortDirection.Desc],
);
export type SupportV2MigrationTeamSortDirection = z.infer<
  typeof SupportV2MigrationTeamSortDirection
>;

export const listSupportV2MigrationTeams = {
  name: "listSupportV2MigrationTeams" as const,
  input: z.object({
    status: SupportV2MigrationTeamStatus.optional(),
    statuses: z.array(SupportV2MigrationTeamStatus).optional(),
    flagEnabled: z.boolean().optional(),
    billingAccepted: z.boolean().optional(),
    search: z.string().optional(),
    sortKey: SupportV2MigrationTeamSortKey.optional(),
    sortDirection: SupportV2MigrationTeamSortDirection.optional(),
    limit: z.number().optional(),
    offset: z.number().optional(),
  }),
  output: z.object({
    teams: z.array(SupportV2MigrationTeamRow),
    total: z.number(),
  }),
};
export type ListSupportV2MigrationTeams = z.infer<
  typeof listSupportV2MigrationTeams.output
>;
